import { axiosInstanceV1 } from "@bn/api";
import {
  ApplicationPropertyList,
  ListAndSearchAllApplicationProperties,
} from "../model";

export const getApplicationProperties = async (
  token: string | undefined,
  params: ListAndSearchAllApplicationProperties
) => {
  const { data } = await axiosInstanceV1.get<ApplicationPropertyList>(
    `/applicationProperties`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params,
    }
  );
  return data;
};
